
import flipkart from '../../../assets/flipkart.webp'
import alibaba from '../../../assets/alibaba.png'
import amazonIN from '../../../assets/amazon.in.png'
import meesho from '../../../assets/meesho.png'
import ebay from '../../../assets/ebay.webp'
import etsy from '../../../assets/etsy.png'
import jiomart from '../../../assets/jiomart.png'
import amazonCOM from '../../../assets/amazon.com'



const data = [
  {
    id:'1',
    image:flipkart,
    header: "CATALOGUE SERVICES FOR FLIPKART",
    para: "K2 E-commerce Solutions is here to help you fly in the world of online retail with its managed catalogue service for Flipkart, one of the biggest online marketplaces in India",
  },
  {
    id:'2',
    image:alibaba,
    header: "ALIBABA GGS SERVICES",
    para: "If you wish to benefit by becoming a seller on the Alibaba platform, you need to register with K2 E-commerce Solutions and then set up your online storefront.",
  },
  {
    id:'3',
    image:amazonIN,
    header: "CATALOGUE SERVICES FOR AMAZON",
    para: "As an Amazon approved catalogue service in India, K2 E-commerce Solutions is here to assist you with getting off to a running start as a retailer on the world’s marketplace.",
  },
  {
    id:'4',
    image:meesho,
    header: "CATALOGUE SERVICES FOR MEESHO",
    para: "If you wish to benefit by becoming a seller on the Meesho platform, you need to register with K2 E-commerce Solutions and then set up your online storefront.",
  },
  {
    id:'5',
    image:ebay,
    header: "CATALOGUE SERVICES FOR EBAY",
    para: "K2 E-commerce Solutions, the leading catalogue service for Ebay in India, offers total assistance to store owners to launch their online presence on Ebay.",
  },
  {
    id:'6',
    image:etsy,
    header: "CATALOGUE SERVICES FOR ETSY",
    para: "If you wish to benefit by becoming a seller on the Etsy platform, you need to register with K2 E-commerce Solutions and then set up your online storefront.",
  },
  {
    id:'7',
    image:jiomart,
    header: "CATALOGUE SERVICES FOR JIOMART",
    para: "If you wish to benefit by becoming a seller on the JioMart platform, you need to register with K2 E-commerce Solutions and then set up your online storefront.",
  },
  {
    id:'8',
    image:amazonCOM,
    header: "CATALOGUE SERVICES FOR AMAZON.COM",
    para: "If you wish to benefit by becoming a seller on the Amazon.com platform, you need to register with K2 E-commerce Solutions and then set up your online storefront.",
  }
];
export default data;
